export const styles = {
  label: 'ml-2 cursor-pointer text-gray-600 hover:text-gray-500 dark:text-gray-300 dark:hover:text-gray-200',
  filterContainer: 'absolute left-12 z-[1000] mt-2.5 w-72 animate-fadeIn overflow-hidden rounded-lg bg-white shadow-lg dark:bg-[#1c1c1f]',
  filterHeader: 'flex items-center justify-between p-4',
  filterTitle: 'text-base font-medium',
  resetButton: 'rounded-full p-1.5 text-gray-500 transition-all duration-200 hover:bg-gray-100 hover:text-primary dark:text-gray-400 dark:hover:bg-gray-800',
  resetIcon: 'text-xl transition-all duration-500',
  contentWrapper: 'select-none divide-y divide-gray-100 dark:divide-gray-800',
  contentSection: 'p-4',
  filterList: 'space-y-4 text-sm',
  optionWrapper: 'flex items-center',
  groupContent: 'mt-2 space-y-2.5 pb-2',
  groupOption: 'ml-3',
  standaloneSection: 'space-y-2.5 pt-2',
} as const; 